export default "__VITE_ASSET__Ve8jyVCo__"